import React from 'react';
import Wrapper from '../../Components/Wrapper/wrapper';
import { TeachersRegistration } from '../../Components/Teachers/TeachersRegistration';

export const RegisterTeachers = () => {
  return (
    <Wrapper header={'Teacher'}>
      <TeachersRegistration />
    </Wrapper>
  );
};
